import styled from "styled-components";

export const Container = styled.div`
  background-color: #f8f8f8;
  padding: 20px;
  width: 100%;
`;

export const CustomLabel = styled.label`
  color: ${({ color }) => color};
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0px;
`;

export const GridGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;

export const ContainerError = styled.div`
  color: red;
  background-color: #ffc0c0;
  border: 1px solid red;
  border-radius: 5px;
  padding: 5px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 10px;
`;
